"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Dataimport = function Dataimport(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "DataimportTitle DataimportDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "DataimportTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "DataimportDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M14.919 10.577l-2.3-2.289v11.086a.6.6 0 0 1-.187.44.606.606 0 0 1-.442.186.597.597 0 0 1-.452-.186.617.617 0 0 1-.177-.44V8.327l-2.28 2.25a.572.572 0 0 1-.442.195.572.572 0 0 1-.442-.195.556.556 0 0 1-.197-.43c0-.17.066-.32.197-.45L12.01 6l3.813 3.697a.89.89 0 0 1 .128.215.596.596 0 0 1 .049.234.604.604 0 0 1-.05.235.597.597 0 0 1-.127.196.623.623 0 0 1-.452.195.623.623 0 0 1-.452-.195zM2 4.279c0-.36.12-.663.361-.91.241-.246.537-.369.889-.369h17.5c.352 0 .648.123.889.37.24.246.361.55.361.91v8.44c0 .347-.12.647-.361.9s-.537.38-.889.38h-5.645v-1.3h4.883a.74.74 0 0 0 .537-.219.726.726 0 0 0 .225-.54V5.06a.759.759 0 0 0-.225-.55.725.725 0 0 0-.537-.23L4.012 4.3a.725.725 0 0 0-.537.23.759.759 0 0 0-.225.55v6.862c0 .214.075.394.225.54a.74.74 0 0 0 .537.22h4.863V14H3.25a1.18 1.18 0 0 1-.889-.38 1.26 1.26 0 0 1-.361-.9V4.28z",
    fillRule: "evenodd"
  }));
};

Dataimport.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Dataimport.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Dataimport;
exports["default"] = _default;